import { StateCreator } from 'zustand';
import { getCustomerModel } from './customer.service.ts';
import {
  CustomerData,
  CustomerDataSchema,
  ICustomerSlice,
  OnboardingTypeEnum,
} from '@Store/index.ts';

export const createCustomerSlice: StateCreator<ICustomerSlice> = (set, get) => ({
  customer: CustomerDataSchema.parse(getCustomerModel()) as CustomerData,
  setCustomerData: (data) => {
    set(() => ({ customer: data }));
  },
  getCustomerData: () => get().customer,
  isMultiBusiness: () =>
    get().customer.customerData.onboardingTypeEnum === OnboardingTypeEnum.MULTI_BUSINESS,
});
